"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MpCheckout = void 0;
var react_1 = __importStar(require("react"));
var mp_context_1 = require("../context/mp-context");
var useMpState_1 = require("../hooks/useMpState");
var MpIframe_1 = require("../iframe/MpIframe");
var useResetStoreOnUnmount_1 = require("../hooks/useResetStoreOnUnmount");
var build_iframe_core_query_params_1 = require("../iframe/build-iframe-core-query-params");
var constants_1 = require("../constants");
var MpCheckout = function (props) {
    var basketId = props.basketId, _a = props.renderUi, renderUi = _a === void 0 ? true : _a;
    var _b = (0, mp_context_1.useMpContext)(), country = _b.country, currency = _b.currency, locale = _b.locale, mpStore = _b.mpStore, platform = _b.platform, reportError = _b.reportError;
    var _c = (0, useMpState_1.useMpState)(), isLoading = _c.isLoading, multiProducts = _c.multiProducts;
    (0, react_1.useEffect)(function () {
        mpStore.getBasketAddOns({ basketId: basketId }).catch(function (error) {
            error = error || new Error(constants_1.UNKNOWN_ERROR);
            error.message = "".concat(constants_1.MULTI_PRODUCT_ERROR_PREFIX, " fetching basket addons: ").concat(error.message);
            if (reportError) {
                reportError(error, constants_1.MULTI_PRODUCT_ACTION_NAME);
            }
        });
    }, [basketId, mpStore, reportError]);
    (0, useResetStoreOnUnmount_1.useResetStoreOnUnMount)();
    if (isLoading || !renderUi || !multiProducts.length) {
        return null;
    }
    var step = 'checkout';
    var siteType = (platform === null || platform === void 0 ? void 0 : platform.toUpperCase()) || '';
    var queryParams = (0, build_iframe_core_query_params_1.buildIframeCoreQueryParams)({
        country: country,
        currency: currency,
        locale: locale,
        step: step,
        siteType: siteType,
    });
    var mfeItems = multiProducts
        .map(function (mpProduct) {
        var productType = mpProduct.productType;
        switch (productType) {
            // INSURANCE MFE
            case 'INSURANCE': {
                var productMFEUrl = mpProduct.productMFEUrl, productId = mpProduct.productId;
                // Extra params specific to the productType
                queryParams.append('quoteId', productId);
                var iframeUrl = "".concat(productMFEUrl, "?").concat(queryParams.toString());
                return (react_1.default.createElement(MpIframe_1.MpIframe, { key: "INSURANCE-".concat(productId), iframeTitle: "Insurance MFE", url: iframeUrl, anchorStep: step, productType: productType, productId: productId }));
            }
            default: {
                return null;
            }
        }
    })
        .filter(function (item) { return item !== null; });
    return react_1.default.createElement(react_1.default.Fragment, null, mfeItems);
};
exports.MpCheckout = MpCheckout;
